import React, { useState, useEffect } from "react";
import { setPageTitle } from "../../../utils/document";
import DashboardLayout from "../../../components/layout/DashboardLayout";
import PositionIDManagement from "../PMO/components/PositionIDManagement";
import AssociateMaster from "../PMO/components/AssociateMaster";
import SCGPool from "../PMO/components/SCGPool";
import Reports from "../PMO/components/Reports";

const HR_TABS = [
  { id: "position-id-management", label: "Position IDs" },
  { id: "associate-master",       label: "Associate Master" },
  { id: "scg-pools",              label: "SCG Pool" },
  { id: "reports",                label: "Reports" },
];

const HRDashboard = () => {
  const [activeTab, setActiveTab] = useState("position-id-management");

  useEffect(() => {
    setPageTitle("HR Dashboard");
  }, []);

  return (
    <DashboardLayout
      tabs={HR_TABS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    >
      {activeTab === "position-id-management" && (
        <PositionIDManagement readOnly />
      )}
      {activeTab === "associate-master" && (
        <AssociateMaster />
      )}
      {activeTab === "scg-pools" && (
        <SCGPool />
      )}
      {activeTab === "reports" && (
        <Reports />
      )}
    </DashboardLayout>
  );
};

export default HRDashboard;
